import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import NavbarAdmin from '../components/navbar/NavbarAdmin';
import Sidebar from '../components/sidebar/Sidebar';
import { getAllClients, deleteClient, banClient, unbanClient, updateClient ,createClientByAdmin} from '../../api/admin';
import swal from 'sweetalert';

const UtilisateursScreen = () => {
  const { slug } = useParams();
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(12);
  const [showModal, setShowModal] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [editName, setEditName] = useState('');
  const [editEmail, setEditEmail] = useState('');
const [showAddModal, setShowAddModal] = useState(false);
const [newClientEmail, setNewClientEmail] = useState('');
const [addingClient, setAddingClient] = useState(false);

  const fetchUsers = async () => {
    try {
      const data = await getAllClients();
      const normalized = data.map(u => ({ ...u, isBanned: !!u.isBanned }));
      setUsers(normalized);
    } catch (_) {}
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleBanToggle = async (id) => {
    const user = users.find((u) => u.id === id);
    if (!user) return;
    setUsers(prev => prev.map(u => (u.id === id ? { ...u, isBanned: !u.isBanned } : u)));
    try {
      if (user.isBanned) {
        await unbanClient(id);
        await swal('Succès', 'Utilisateur débanni', 'success');
      } else {
        await banClient(id);
        await swal('Succès', 'Utilisateur banni', 'success');
      }
    } catch (_) {
      setUsers(prev => prev.map(u => (u.id === id ? { ...u, isBanned: user.isBanned } : u)));
    }
  };

  const handleDelete = async (id) => {
    const confirm = await swal({
      title: 'Supprimer ?',
      text: 'Cette action est irréversible',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    });
    if (confirm) {
      const oldUsers = [...users];
      setUsers(prev => prev.filter((u) => u.id !== id));
      try {
        await deleteClient(id);
        await swal('Supprimé', 'Utilisateur supprimé', 'success');
      } catch (_) {
        setUsers(oldUsers);
        await swal('Erreur', 'Impossible de supprimer', 'error');
      }
    }
  };

  const handleEditClick = (user) => {
    setEditingUser(user);
    setEditName(user.name);
    setEditEmail(user.email);
    setShowModal(true);
  };

  const handleSave = async () => {
    const id = editingUser.id;
    setUsers(prev => prev.map(u => (u.id === id ? { ...u, name: editName, email: editEmail } : u)));
    setShowModal(false);
    try {
      await updateClient(id, { name: editName, email: editEmail });
      await swal('Succès', 'Utilisateur modifié', 'success');
    } catch (_) {
      await swal('Erreur', 'Modification échouée', 'error');
      fetchUsers();
    }
  };

  const filteredUsers = users.filter((user) =>
    user.name.toLowerCase().includes(search.toLowerCase()) ||
    user.email.toLowerCase().includes(search.toLowerCase())
  );

  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);
  const paginatedUsers = filteredUsers.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="flex min-h-screen bg-gray-100">
      <div className="fixed top-0 w-full md:hidden z-50">
        <NavbarAdmin slug={slug} />
      </div>
      <div className="hidden md:flex">
        <Sidebar slug={slug} />
      </div>

      <main className="flex-1 md:ml-64 p-4 pt-20 md:pt-6 w-full">
        <h1 className="text-2xl font-bold mb-4 text-paragaia">Gestion des utilisateurs</h1>
        <button
        onClick={() => setShowAddModal(true)}
        className="px-4 py-2 bg-paragaia text-white rounded hover:opacity-90 mb-4"
        >
        Ajouter un client
        </button>
        {showAddModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
            <h2 className="text-lg font-semibold mb-4">Ajouter un client</h2>
            <div className="mb-3">
                <label className="block mb-1">Email</label>
                <input
                type="email"
                className="w-full px-4 py-2 border rounded"
                value={newClientEmail}
                onChange={(e) => setNewClientEmail(e.target.value)}
                />
            </div>
            <div className="flex justify-end gap-2 mt-4">
                <button
                className="px-4 py-2 bg-gray-300 hover:bg-gray-400 rounded"
                onClick={() => {
                    setShowAddModal(false);
                    setNewClientEmail('');
                }}
                >
                Annuler
                </button>
                <button
                className="px-4 py-2 bg-paragaia text-white hover:opacity-90 rounded"
                disabled={addingClient}
                onClick={async () => {
                    if (!newClientEmail) {
                    await swal('Erreur', 'Veuillez entrer un email valide.', 'error');
                    return;
                    }
                    const alreadyExists = users.find(u => u.email.toLowerCase() === newClientEmail.toLowerCase());
                    if (alreadyExists) {
                    await swal('Erreur', 'Cet email est déjà utilisé.', 'error');
                    return;
                    }
                    setAddingClient(true);
                    try {
                    await createClientByAdmin(newClientEmail);
                    await swal('Succès', 'Client ajouté avec succès.', 'success');
                    setShowAddModal(false);
                    setNewClientEmail('');
                    fetchUsers();
                    } catch (_) {}
                    setAddingClient(false);
                }}
                >
                Ajouter
                </button>
            </div>
            </div>
        </div>
        )}


        <div className="flex flex-col md:flex-row justify-between items-center mb-4 gap-4">
          <input
            type="text"
            placeholder="Rechercher un utilisateur..."
            className="w-full md:w-1/3 px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-paragaia"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setCurrentPage(1);
            }}
          />
          <select
            value={itemsPerPage}
            onChange={(e) => {
              setItemsPerPage(Number(e.target.value));
              setCurrentPage(1);
            }}
            className="w-36 px-4 py-2 border border-gray-300 rounded"
          >
            <option value={12}>12 par page</option>
            <option value={24}>24 par page</option>
            <option value={36}>36 par page</option>
          </select>
        </div>
        


        <div className="bg-white rounded-lg shadow-md overflow-hidden">
  <div className="hidden md:block">
    <table className="min-w-full text-sm text-gray-700">
      <thead className="bg-gray-100">
        <tr>
          <th className="px-4 py-3 text-left">Nom</th>
          <th className="px-4 py-3 text-left">Email</th>
          <th className="px-4 py-3 text-left">Statut</th>
          <th className="px-4 py-3 text-center">Actions</th>
        </tr>
      </thead>
      <tbody>
        {paginatedUsers.map((user) => (
          <tr key={user.id} className="border-t hover:bg-gray-50 transition">
            <td className="px-4 py-2">{user.name}</td>
            <td className="px-4 py-2">{user.email}</td>
            <td className="px-4 py-2">
              {user.isBanned ? (
                <span className="text-xs bg-red-100 text-red-600 rounded-full px-2 py-1">Banni</span>
              ) : (
                <span className="text-xs bg-green-100 text-green-700 rounded-full px-2 py-1">Actif</span>
              )}
            </td>
            <td className="px-4 py-2 text-center space-x-2">
              <button
                className="px-3 py-1 bg-yellow-500 hover:bg-yellow-600 text-white rounded"
                onClick={() => handleEditClick(user)}
              >
                Éditer
              </button>
              <button
                className="px-3 py-1 bg-red-500 hover:bg-red-600 text-white rounded"
                onClick={() => handleDelete(user.id)}
              >
                Supprimer
              </button>
              <button
                className={`px-3 py-1 ${
                  user.isBanned ? 'bg-green-500' : 'bg-gray-800'
                } hover:opacity-80 text-white rounded`}
                onClick={() => handleBanToggle(user.id)}
              >
                {user.isBanned ? 'Débannir' : 'Bannir'}
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>

        <div className="md:hidden divide-y">
            {paginatedUsers.map((user) => (
            <div key={user.id} className="p-4">
                <div className="mb-2">
                <p className="font-medium text-gray-800">{user.name}</p>
                <p className="text-sm text-gray-500">{user.email}</p>
                </div>
                <div className="flex justify-between items-center flex-wrap gap-2 mt-2">
                <span
                    className={`text-xs px-2 py-1 rounded-full ${
                    user.isBanned ? 'bg-red-100 text-red-600' : 'bg-green-100 text-green-700'
                    }`}
                >
                    {user.isBanned ? 'Banni' : 'Actif'}
                </span>
                <div className="flex flex-wrap gap-2 mt-2">
                    <button
                    className="px-3 py-1 bg-yellow-500 text-white rounded text-sm"
                    onClick={() => handleEditClick(user)}
                    >
                    Éditer
                    </button>
                    <button
                    className="px-3 py-1 bg-red-500 text-white rounded text-sm"
                    onClick={() => handleDelete(user.id)}
                    >
                    Supprimer
                    </button>
                    <button
                    className={`px-3 py-1 text-white rounded text-sm ${
                        user.isBanned ? 'bg-green-500' : 'bg-gray-800'
                    }`}
                    onClick={() => handleBanToggle(user.id)}
                    >
                    {user.isBanned ? 'Débannir' : 'Bannir'}
                    </button>
                </div>
                </div>
            </div>
            ))}
            {paginatedUsers.length === 0 && (
            <p className="text-center text-gray-500 py-6">Aucun utilisateur trouvé.</p>
            )}
        </div>
        </div>
        {totalPages > 1 && (
          <div className="flex justify-center mt-6 space-x-1 items-center">
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(currentPage - 1)}
              className={`px-3 py-1 rounded border ${
                currentPage === 1 ? 'opacity-50 cursor-not-allowed' : 'bg-white hover:bg-gray-200'
              }`}
            >
              &lt;
            </button>

            {Array.from({ length: totalPages }, (_, i) => i + 1)
              .filter((page) => {
                if (page === 1 || page === totalPages) return true;
                if (page >= currentPage - 2 && page <= currentPage + 2) return true;
                return false;
              })
              .map((page, i, arr) => {
                const prev = arr[i - 1];
                const isGap = prev && page - prev > 1;
                return (
                  <span key={page} className="flex items-center">
                    {isGap && <span className="px-2 text-gray-500">...</span>}
                    <button
                      onClick={() => setCurrentPage(page)}
                      className={`px-3 py-1 rounded border ${
                        currentPage === page
                          ? 'bg-paragaia text-white'
                          : 'bg-white text-paragaia hover:bg-paragaiaLight'
                      }`}
                    >
                      {page}
                    </button>
                  </span>
                );
              })}

            <button
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(currentPage + 1)}
              className={`px-3 py-1 rounded border ${
                currentPage === totalPages ? 'opacity-50 cursor-not-allowed' : 'bg-white hover:bg-gray-200'
              }`}
            >
              &gt;
            </button>
          </div>
        )}


        {showModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
              <h2 className="text-lg font-semibold mb-4">Modifier l’utilisateur</h2>
              <div className="mb-3">
                <label className="block mb-1">Nom</label>
                <input
                  type="text"
                  className="w-full px-4 py-2 border rounded"
                  value={editName}
                  onChange={(e) => setEditName(e.target.value)}
                />
              </div>
              <div className="mb-3">
                <label className="block mb-1">Email</label>
                <input
                  type="email"
                  className="w-full px-4 py-2 border rounded"
                  value={editEmail}
                  onChange={(e) => setEditEmail(e.target.value)}
                />
              </div>
              <div className="flex justify-end gap-2 mt-4">
                <button
                  className="px-4 py-2 bg-gray-300 hover:bg-gray-400 rounded"
                  onClick={() => setShowModal(false)}
                >
                  Annuler
                </button>
                <button
                  className="px-4 py-2 bg-paragaia text-white hover:opacity-90 rounded"
                  onClick={handleSave}
                >
                  Enregistrer
                </button>
              </div>
            </div>
          </div>
        )}
      </main>
    </div>
  );
};

export default UtilisateursScreen;
